<!-- gantt-chart.component.html -->
<div class="custom-gantt">
  <div class="gantt-controls">
    <div class="scale-buttons">
      <button (click)="setYearScale(); goToday()" [class.active]="currentScale === 'year'">Год</button>
      <button (click)="setMonthScale(); goToday()" [class.active]="currentScale === 'month'">Месяц</button>
      <button (click)="setWeekScale(); goToday()" [class.active]="currentScale === 'week'">Неделя</button>
    </div>

    <div class="nav-buttons">
      <button (click)="goPrev()" class="nav-btn">◀ Предыдущий</button>
      <button (click)="goToday()" class="today-btn">📅 Текущий период</button>
      <button (click)="goNext()" class="nav-btn">Следующий ▶</button>
    </div>

    <div class="period-title">{{ currentPeriodTitle }}</div>
  </div>

  

  <div class="gantt-container" *ngIf="bookingGroups.length > 0; else noData">
    <div class="gantt">
      <!-- Шапка с датами -->
      <div class="gantt-header">
        <div class="gantt-row-first">Название</div>
        <div class="gantt-timeline" style="position: relative;">
          <div *ngFor="let col of displayColumns" 
               class="gantt-date-cell" 
               [class.weekend]="col.isWeekend"
               [class.current-day]="col.fullDate && isCurrentPeriod(col.fullDate)"
               [style.minWidth.px]="currentScale === 'year' ? 100 : 60">
            {{ col.label }}
          </div>
        </div>
      </div>

      <!-- ДЛЯ ГОДА -->
      <ng-container *ngIf="currentScale === 'year'">
        <div *ngFor="let group of bookingGroups" class="gantt-row">
          <div class="gantt-row-first">{{ group.name }}</div>
          <div class="gantt-timeline year-timeline" style="position: relative;">
            
            <!-- Область периода (заливка + границы) -->
            <div class="period-area"
                 [style.left]="getYearPeriodAreaStyle(group).left"
                 [style.width]="getYearPeriodAreaStyle(group).width"
                 [style.borderLeft]="getYearPeriodAreaStyle(group).borderLeft"
                 [style.borderRight]="getYearPeriodAreaStyle(group).borderRight"
                 [style.backgroundColor]="getYearPeriodAreaStyle(group).backgroundColor"
                 [style.display]="getYearPeriodAreaStyle(group).display">
            </div>
            
            <!-- Месяцы -->
            <div *ngFor="let month of displayColumns; let monthIndex = index" 
                 class="month-cell"
                 [style.left]="(monthIndex / displayColumns.length) * 100 + '%'"
                 [style.width]="(100 / displayColumns.length) + '%'">
              
              <ng-container *ngFor="let booking of getBookingsForMonth(month)">
                <div *ngIf="booking.group === group" 
                     class="booking-bar-inside-month"
                     [style.left]="getBookingPositionInMonth(booking.start, booking.end, month.start, month.end).leftPercent + '%'"
                     [style.width]="getBookingPositionInMonth(booking.start, booking.end, month.start, month.end).widthPercent + '%'"
                     [style.backgroundColor]="booking.booking?.isAvailable === false ? '#dc3545' : '#3156f8'"
                     [attr.title]="booking.name + ': ' + formatTooltip(booking.start.getTime()) + ' - ' + formatTooltip(booking.end.getTime()) + (booking.booking?.isAvailable === false ? ' (ЗАНЯТО)' : '')">
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ДЛЯ МЕСЯЦА -->
      <ng-container *ngIf="currentScale === 'month'">
        <div *ngFor="let group of bookingGroups" class="gantt-row">
          <div class="gantt-row-first">{{ group.name }}</div>
          <div class="gantt-timeline" style="position: relative;">
            
            <!-- Область периода (заливка + границы) -->
            <div class="period-area"
                 [style.left]="getPeriodAreaStyle(group).left"
                 [style.width]="getPeriodAreaStyle(group).width"
                 [style.borderLeft]="getPeriodAreaStyle(group).borderLeft"
                 [style.borderRight]="getPeriodAreaStyle(group).borderRight"
                 [style.backgroundColor]="getPeriodAreaStyle(group).backgroundColor"
                 [style.display]="getPeriodAreaStyle(group).display">
            </div>
            
            <!-- Полоски бронирований -->
            <div *ngFor="let booking of getAllBookingsForRow(group)">
              <div class="booking-bar" 
                   [style.left]="getBookingStyle(booking).left" 
                   [style.width]="getBookingStyle(booking).width"
                   [style.backgroundColor]="getBookingStyle(booking).backgroundColor"
                   [attr.title]="booking.name + ': ' + formatTooltip(booking.start) + ' - ' + formatTooltip(booking.end) + (booking.isAvailable === false ? ' (ЗАНЯТО)' : '')">
                
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ДЛЯ НЕДЕЛИ -->
      <ng-container *ngIf="currentScale === 'week'">
        <div *ngFor="let group of bookingGroups" class="gantt-row">
          <div class="gantt-row-first">{{ group.name }}</div>
          <div class="gantt-timeline" style="position: relative;">
            
            <!-- Область периода (заливка + границы) -->
            <div class="period-area"
                 [style.left]="getPeriodAreaStyle(group).left"
                 [style.width]="getPeriodAreaStyle(group).width"
                 [style.borderLeft]="getPeriodAreaStyle(group).borderLeft"
                 [style.borderRight]="getPeriodAreaStyle(group).borderRight"
                 [style.backgroundColor]="getPeriodAreaStyle(group).backgroundColor"
                 [style.display]="getPeriodAreaStyle(group).display">
            </div>
            
            <!-- Полоски бронирований -->
            <div *ngFor="let booking of getAllBookingsForRow(group)">
              <div class="booking-bar" 
                   [style.left]="getBookingStyle(booking).left" 
                   [style.width]="getBookingStyle(booking).width"
                   [style.backgroundColor]="getBookingStyle(booking).backgroundColor"
                   [attr.title]="booking.name + ': ' + formatTooltip(booking.start) + ' - ' + formatTooltip(booking.end) + (booking.isAvailable === false ? ' (ЗАНЯТО)' : '')">
                
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #noData>
    <div class="no-data">Нет данных для отображения</div>
  </ng-template>
</div>